import { getFoodieById } from "services/SauceService";

export async function creatorLoader(props: any) {
  const response: any = await getFoodieById(props.params.id);
  return response;
}
